// React
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect as reduxConnect } from 'react-redux'

// Libraries
import { withTranslation } from 'shared/utils/withTranslation'

// Components

// Shared
import { setFilterFilterBy } from 'store/v2/redux/actions/filter'

export class FilterSelect extends Component {
  static displayName = 'FilterSelect'

  static propTypes = {
    filterBy: PropTypes.string,
    handleChangeFilter: PropTypes.func,
    useAvailability: PropTypes.bool
  }

  get options () {
    const { useAvailability, t } = this.props
    const options = [
      {
        label: t('user.store.filter_all'),
        value: null
      }
    ]

    if (useAvailability) {
      options.push(
        {
          label: t('user.store.filter_available'),
          value: 'available'
        }
      )
    }

    return options
  }

  render () {
    const { filterBy, handleChangeFilter } = this.props

    return (
      <div className="select-container bq-filter-select">
        <select
          name="filter"
          className="bq-filter"
          onChange={handleChangeFilter}
          value={filterBy}
        >
          {this.options.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
      </div>
    )
  }
}

const mapStateToProps = (state, props) => {
  const filter = state.filter.get(props.filterKey || 'global')
  const filterBy = (filter && filter.get('filter_by')) || undefined

  return {
    useAvailability: state.settings.get('store.use_availability'),
    filterBy
  }
}

const mapDispatchToProps = (_dispatch, props) => {
  return {
    handleChangeFilter: (event) => {
      const value = event.target.value

      setFilterFilterBy(value, props.filterKey || 'global')
    }
  }
}

const reduxComponent = reduxConnect(mapStateToProps, mapDispatchToProps)(FilterSelect)

export default withTranslation('user')(reduxComponent)

